// extracted by mini-css-extract-plugin
export default {"img":"style_img__M6Zzo"};